export const shops = {
  shop_name: "所属名",
  select_genre: "ジャンルを選んでください",
  edit_text: "グレー部分の編集は運営の承認が必要です。修正を希望される場合はお問い合わせよりご連絡ください。",
  show: '表示',
  hide: '非表示',
  index: {
    shop_management: '所属管理',
    search: '所属検索'
  },
  form: {
    input_labels: {
      id: '所属コード',
      company: '企業名',
      name: '所属名',
      genre: 'ジャンル',
      seat: '席数',
      representative_name: '所属責任者名',
      zip_code: '所在地',
      prefectures: '都道府県',
      city: '市区町村',
      address_number: '番地',
      house: 'マンション名・建物名など',
      tel: '電話番号（ハイフンあり）',
      mail_address: 'メールアドレス',
      homepage_url: 'ホームページ',
      memo: 'メモ',
      login_id: 'ログインID (半角英数字8文字以上)',
      status: '有効・無効',
      is_display: '表示・非表示',
      description: '所属下表示 自由テキスト',
    },
    input_placeholder: {
      name: '所属名',
      company: '企業名',
      genre: 'ジャンル',
      seat: '席数',
      representative_name: '所属責任者名',
      zip_code: '郵便番号（ハイフンなし）',
      prefectures: '都道府県',
      city: '市区町村',
      address_number: '番地',
      house: 'マンション名・建物名など',
      tel: '電話番号（ハイフンあり）',
      mail_address: 'メールアドレス',
      homepage_url: 'ホームページ',
      memo: 'メモ',
      login_id: 'ログインID',
      status: '有効・無効',
      description: '所属下表示 自由テキスト',
    },
    zip_code: '郵便番号',
    login_id: 'ログインID',
    btn_search_by_zip_code: '郵便番号から検索',
    account_info: 'アカウント情報（管理画面に入る際に必要です）',
  },
  detail_fields: {
    company_name: '企業名',
    genre: 'ジャンル',
    seat: '席数',
    representative_name: '所属責任者名',
    address: '所在地',
    tel: '電話番号',
    mail_address: 'メールアドレス',
    homepage_url: 'ホームページ',
    memo: 'メモ',
    bank_name: '銀行名',
    branch_name: '店番号',
    bank_account_type: '普通・当座',
    bank_account: '口座番号',
    bank_account_holder: '口座名義',
    register_date: '初回登録日',
    last_login_date: '最終ログイン日',
    login_id: 'ログインID',
    password: 'パスワード',
    status: '有効・無効',
    is_display: '表示・非表示',
    checkin_url: 'チェックインURL',
    checkin_liff: 'チェックインURL',
    checkin_url_create_staff: 'メンバー登録URL',
    description: '所属下表示 自由テキスト',
  }
}
